///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.pricing_team = abcsetup.dashboard.pricing_team || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.pricing_team = {

    init: function () {
        require('../abc_item/pricing/_manage');
        abcsetup.abc_item_pricing.manage._init();

        $(document).on('change', '.pricing_not_needed_all', function () {
            const isChecked = $(this).is(':checked');
            $('input[type="checkbox"]').not(this).prop('checked', isChecked);
        });

        $(document).on('change', 'input[type="checkbox"]', function () {
            const anyChecked = $('input[type="checkbox"]:checked').length > 0;

            if (anyChecked) {
                $('#pricing-not-needed-btn').removeAttr('hidden');
            } else {
                $('#pricing-not-needed-btn').attr('hidden', true);
            }
        });

        $(document).on('click', '#pricing-not-needed-btn', function () {
            abcsetup.blockUI(true);
            const selectedIds = [];
            $('.pricing_not_needed_checkbox:checked').each(function () {
                selectedIds.push($(this).data('id'));
            });
        
            axios.post('/api/abc_item_pricing/pricing_not_needed', {
                ids: selectedIds
            })
            .then(success => {
                window.location.reload();
            })
            .catch(error => {
                abcsetup.unblockUI();
            });
        });

        // Pricing Edit modal shown
        $('#edit-pricing').on('show.bs.modal', function (e) {
            $(this).find('.modal-body').html('<center>Loading Pricing Information...</center>');
            axios.get('/api/abc_item_pricing/edit?sap_num=' + $(e.relatedTarget).data('sap_num')).then(response => {
                $(this).find('.modal-feedback').html("");
                $(this).find('.modal-body').html(response.data);
                abcsetup.abc_item_pricing.manage._init_copy();
                abcsetup.abc_item_pricing.manage.calc_margins();

                var sap_num = $("#pricing_modal_sap_num").val();
                var mat_description = $("#pricing_modal_mat_description").val();
                var pricing_data = JSON.parse($("#pricing_modal_pricing_data").val());
                var num = $("#pricing_modal_id").val();
                var tr = $(".pricing_update_form.row." + num);
                var map_price = tr.data("map_price");
                var wac_price = tr.data("wac");
                abcsetup.abc_item_pricing.manage.check_imported_pricing(sap_num);
                abcsetup.abc_item_pricing.manage.test_all_zone_prices(num, map_price, wac_price, pricing_data);

                $('.edit-pricing').append(' - SAP # : ' + sap_num + ' - Description : ' + mat_description);
                
            });
        });

        $('#edit-pricing').on('hidden.bs.modal', function() {
            $('.edit-pricing').text('Edit Pricing');
        });
    },
};